import { Form, Modal, IFormContext }   from 'rewire-ui';
import { ISearchResult }               from '../DataTypes';
import { getAdvancedFormAutoComplete } from '../ui/AdvancedAutoComplete';
import { getNameSearcher }             from '../utility/Searchers';

const employeeSearcher = getNameSearcher('employees');

export class SelectEmployeeDialogModel extends Modal {
  form: Form;
  callback: (returnData: ISearchResult) => void;

  constructor() {
    super('Select Employee');
    this.form = Form.create((form: IFormContext) => ({
      employee: getAdvancedFormAutoComplete(form, employeeSearcher).label('Employee').placeholder('select an employee').validators('required').autoFocus(),
    }));
    this.action('cancel')
        .action('select', this.submit, {variant: 'contained', type: 'submit'});
  }

  reset() {
    this.form.reset();
  }

  load = async (callback: (returnData: ISearchResult) => void) => {
    this.callback = callback;
    this.reset();
    this.open();
  };

  submit = async () => {
    if (!this.form.submit()) return false;

    const selectedEmployee = this.form.field.employee.value;
    if (this.callback) {
      this.callback(selectedEmployee);
    }
    return true;
  };
}

const selectEmployeeDialogModel = new SelectEmployeeDialogModel();
export default selectEmployeeDialogModel;